import React from "react";
// @ts-ignore
import Icon from "@fdr/static-ui/Icons";
// @ts-ignore
import { fanduel } from "@fdr/static-ui/Icons/icons";
// @ts-ignore
import buildColor from "@fdr/static-ui/ColorPalette";
import {
  InvalidResidentialAddressErrorWrapper,
  InvalidResidentialAddressErrorMessages,
  IconWrapper
} from "./styled-components";
import { Props } from "./types";

const renderErrorMessages = (errorMessages: string[]) =>
  errorMessages.length > 0 &&
  errorMessages.map((errorMessage: string) => (
    <InvalidResidentialAddressErrorMessages
      dangerouslySetInnerHTML={{ __html: errorMessage }}
      key={errorMessage}
    />
  ));

export const InvalidResidentialAddressError = ({
  qaLabel = "invalidResidentialAddress",
  errorMessages = [],
  isSplashScreen
}: Props) => (
  <InvalidResidentialAddressErrorWrapper
    data-qa-label={qaLabel}
    isSplashScreen={isSplashScreen}
  >
    <IconWrapper>
      <Icon icon={fanduel} color={buildColor("blue")} size="76" />
    </IconWrapper>
    {renderErrorMessages(errorMessages)}
  </InvalidResidentialAddressErrorWrapper>
);

export default InvalidResidentialAddressError;
